import educationValidation from './educationValidation';

export default {
  type: 'object',
  properties: {
    ...educationValidation,
  },
};
